<template>
  <div>
    <h1>环境控制</h1>
  </div>
</template>
<script>
export default {
  name: 'Environment',
  data() {
    return {}
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>


// WEBPACK FOOTER //
// src/components/product/operate/Environment.vue